import { useSelector } from 'hooks/utils';
import { selectTemplateById } from 'store/data/templates';

export function useTemplateById(templateId: string) {
	return useSelector(state => selectTemplateById(state.data.templates, templateId));
}
